import type { ReactNode } from 'react'
import {

  QueryClientProvider as TanStackQueryClientProvider,
} from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { useZebraOfflineScanReconnectSync } from '@/features/order/lib/useZebraOfflineScanReconnectSync'
import { queryClient } from '@/shared/lib/tanstack-query'

interface QueryClientProviderProps {
  children: ReactNode
}

function ZebraOfflineScanReconnectBridge() {
  useZebraOfflineScanReconnectSync()
  return null
}

export function QueryClientProvider({ children }: QueryClientProviderProps) {
  return (
    <TanStackQueryClientProvider client={queryClient}>
      {children}
      <ZebraOfflineScanReconnectBridge />
      <ReactQueryDevtools
        initialIsOpen={false}
      />
    </TanStackQueryClientProvider>
  )
}
